import CheckIcon from 'components/Icons/CheckIcon';
import React, { FC, useEffect, useMemo, useRef } from 'react';
import { isMobile } from 'react-device-detect';

export interface DropdownOptions {
  onClick: () => void;
  label: string;
  checked?: boolean;
  icon?: JSX.Element;
}

interface DropdownProps {
  close: () => void;
  open: boolean;
  id: string;
  options?: DropdownOptions[];
}

export const Dropdown: FC<DropdownProps> = (props) => {
  const { open, options, close, id } = props;

  const dropRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const onClick = (e: MouseEvent) => {
      const hasDivRef = dropRef.current !== null;

      const isCludedElement = dropRef.current.contains(e.target as Node);

      if (hasDivRef && !isCludedElement) close();
    };

    if (open) window.addEventListener('click', onClick);

    return () => {
      window.removeEventListener('click', onClick);
    };
  }, [dropRef, open, close]);

  const dropdownClass = useMemo(() => (open ? 'active fade-in' : 'inactive fade-out'), [open]);

  return (
    <>
      {open && <div className="beneficiaries-mobile-dropdown-overlay" />}
      <div ref={dropRef} className={`menu ${dropdownClass}`}>
        <div className="dropdown-space fade-in" />
        {isMobile && (
          <button onClick={close} className="dropdown-list center" type="button" data-testid={`close-${id}`}>
            <i className="material-icons">expand_more</i>
          </button>
        )}
        {options.map((option, index) => {
          const isLast = options.length - 1 === index;

          return (
            <div key={option.label}>
              <button
                type="button"
                id={`${id}-${index}`}
                data-testid={`${id}-${index}`}
                className={`dropdown-list ${option.checked ? 'active' : ''}`}
                onClick={option.onClick}
              >
                <span className="flex-grow-1">
                  {option.icon} {option.label}
                </span>
                {option.checked && <CheckIcon />}
              </button>
              {!isLast && <hr className="divider" />}
            </div>
          );
        })}
        <div className="dropdown-space" />
      </div>
    </>
  );
};
